export default __webpack_public_path__ + "static/media/Perk_1.f19d8794.png";